import {
  FIELD_ASSIGNEE_ID_KEY,
  FIELD_AVAILABILITY_KEY,
  FIELD_BOOKING_CATEGORY_ID_KEY,
  FIELD_DESCRIPTION_KEY,
  FIELD_MIN_REQUIRED_COUNT_KEY,
  FIELD_NAME_KEY,
  FIELD_PARENT_ACTIVITY_KEY,
  FIELD_POST_UNTIL_KEY,
  FIELD_SUBTEMPLATE_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { FormSchemaField } from "PFApp/types/activity_form/activity_form_schema";
import { Subtemplate, Template } from "PFCore/types";
import { useCallback } from "react";

import { useIsAssigneeRequired } from "./use_is_assignee_required";

const HARDCODED_REQUIRED_FIELDS = [
  FIELD_SUBTEMPLATE_KEY,
  FIELD_NAME_KEY,
  FIELD_DESCRIPTION_KEY,
  FIELD_MIN_REQUIRED_COUNT_KEY,
  FIELD_POST_UNTIL_KEY
];

type UseFormValidationParams = {
  subtemplate: Subtemplate | null;
  template: Template;
  isAssigneeOptional?: boolean;
};

export const useFormValidation = ({ subtemplate, template, isAssigneeOptional }: UseFormValidationParams) => {
  const isAssigneeRequired = useIsAssigneeRequired();

  const isFieldRequired = useCallback(
    (field: FormSchemaField) => {
      if (HARDCODED_REQUIRED_FIELDS.includes(field.name)) {
        return true;
      }

      if (field.name === FIELD_ASSIGNEE_ID_KEY) {
        return !isAssigneeOptional && isAssigneeRequired(template);
      }

      if (field.name === FIELD_PARENT_ACTIVITY_KEY) {
        return template.requires_parent_activity_id;
      }

      if (
        !subtemplate ||
        field.segment ||
        field.match ||
        [FIELD_AVAILABILITY_KEY, FIELD_BOOKING_CATEGORY_ID_KEY].includes(field.name)
      ) {
        return template.schema.required.includes(field.name);
      }

      return subtemplate.schema.required.includes(field.name);
    },
    [isAssigneeRequired, isAssigneeOptional, subtemplate, template]
  );

  return { isFieldRequired };
};
